// eslint-disable-next-line no-redeclare,no-unused-vars
function convertBack(value, settings) {
  if ((settings.number || settings.decimal) && !settings.timestamp) {
    if (value) value = parseFloat(value.replaceAll('.', '').replace(',', '.'));
    else value = 0;
  } else if (settings.field == 'color' && value == '#ffffff') value = '';
  return value;
}
